import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.scss';
import { useAppContext } from './AppContext';
import { customStorage, getPayloadData, isInRole, isNullOrEmptyString } from '../services/UtilityService';
import ConfirmDialog from './ConfirmDialog';
import { RG_ADMIN, RG_ALL_ROLES, RG_SYSTEM_ADMIN } from '../constants/roleConstants';
import { ROUTE_ADMIN_ACCOUNTS, ROUTE_ADMIN_DASHBOARD, ROUTE_CATEGORY_CREATE, ROUTE_CATEGORY_LIST, ROUTE_PRODUCT_CREATE, ROUTE_PRODUCT_LIST, ROUTE_PURCHASE_PRODUCT, ROUTE_PURCHASE_LIST, ROUTE_ORDER_CREATE, ROUTE_ORDER_LIST, ROUTE_PROFIT_LOSS_CALCULATE, ROUTE_POSTED_LINKS, ROUTE_SHOP_LIST, ROUTE_ADD_SHOP, ROUTE_OUTOFSTOCKS, ROUTE_MONTHLY_REPORTS, ROUTE_GENERAL_EXPEND_LIST, ROUTE_ADD_GENERAL_EXPEND, ROUTE_MONEY_ADJUSTMENT_LIST, ROUTE_ADD_MONEY_ADJUSTMENT, ROUTE_PRINT_PDF, ROUTE_INSTOCKS, ROUTE_SEND_STOCK_HISTORIES } from '../constants/routeConstants';
import { APP_BRAND_NAME, MAIN_MENU_CATEGORY, MAIN_MENU_GENERAL_EXPEND, MAIN_MENU_INSTOCK_ADJUSTMENT, MAIN_MENU_MANAGEMENT, MAIN_MENU_MONEY_ADJUSTMENT, MAIN_MENU_ORDER, MAIN_MENU_PRINT_PDF, MAIN_MENU_PRODUCT, MAIN_MENU_PURCHASE, MAIN_MENU_SETTING, MAIN_MENU_SHOP, MAIN_MENU_SYSTEM_ADMIN, REFRESH_TOKEN_KEY, SERVER_ERROR_MESSAGE, TOKEN_SESSION_KEY } from '../constants/commonConstants';
import CommonDialog from './CommonDialog';
import { changePassword } from '../services/AccountService';
import * as Yup from 'yup';
import { Button, Card, Container } from 'react-bootstrap';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import AlertDialog from './AlertDialog';
import { changeUsername } from '../services/AuthService';

const Navbar = () => {

    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    const currentUser = getPayloadData(token);

    const { logout, mainMenu, setLoading, setToken, setShowApiErrorMessage, routeNaviData } = useAppContext();
    const [showLogoutConfirmDialog, setShowLogoutConfirmDialog] = useState(false);
    const [showChangeUserNameDialog, setShowChangeUserNameDialog] = useState(false);
    const [showChangePasswordDialog, setShowChangePasswordDialog] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [showSuccessPasswordChangedDialog, setShowSuccessPasswordChangedDialog] = useState(false);
    const offcanvasCloseBtnRef = useRef(null);

    const menuList = [
        {
            main: MAIN_MENU_SYSTEM_ADMIN,
            children: [
                {
                    menuName: 'Admin List',
                    checkRoles: RG_SYSTEM_ADMIN,
                    gotoPage: ROUTE_ADMIN_ACCOUNTS,
                    onClick: null
                },
            ]
        },
        {
            main: MAIN_MENU_MANAGEMENT,
            children: [
                {
                    menuName: 'Dashboard',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_ADMIN_DASHBOARD,
                    onClick: null
                },
                {
                    menuName: 'Profit Calculate',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_PROFIT_LOSS_CALCULATE,
                    onClick: null
                },
                {
                    menuName: 'Locked Reports',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_MONTHLY_REPORTS,
                    onClick: null
                },
                {
                    menuName: 'Social Links',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_POSTED_LINKS,
                    onClick: null
                },
                {
                    menuName: 'Print PDF',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_PRINT_PDF,
                    onClick: null
                }
            ]
        },
        {
            main: MAIN_MENU_PURCHASE,
            children: [
                {
                    menuName: 'Purchase List',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_PURCHASE_LIST,
                    onClick: null
                },
                {
                    menuName: 'New Purchase',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_PURCHASE_PRODUCT,
                    onClick: null
                },
            ]
        },
        {
            main: MAIN_MENU_ORDER,
            children: [
                {
                    menuName: 'Order List',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_ORDER_LIST,
                    onClick: null
                },
                {
                    menuName: 'New Order',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_ORDER_CREATE,
                    onClick: null
                },
            ]
        },
        {
            main: MAIN_MENU_PRODUCT,
            children: [
                {
                    menuName: 'Product List',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_PRODUCT_LIST,
                    onClick: null
                },
                {
                    menuName: 'New Product',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_PRODUCT_CREATE,
                    onClick: null
                }
            ]
        },
        {
            main: MAIN_MENU_INSTOCK_ADJUSTMENT,
            children: [
                {
                    menuName: 'Out Of Stocks',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_OUTOFSTOCKS,
                    onClick: null
                },
                {
                    menuName: 'Stock List',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_INSTOCKS,
                    onClick: null
                },
                {
                    menuName: 'Stock Transfer Histories',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_SEND_STOCK_HISTORIES,
                    onClick: null
                },
            ]
        },
        {
            main: MAIN_MENU_GENERAL_EXPEND,
            children: [
                {
                    menuName: 'Expend List',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_GENERAL_EXPEND_LIST,
                    onClick: null
                },
                {
                    menuName: 'New Expend',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_ADD_GENERAL_EXPEND,
                    onClick: null
                }
            ]
        },
        {
            main: MAIN_MENU_MONEY_ADJUSTMENT,
            children: [
                {
                    menuName: 'Adjustment List',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_MONEY_ADJUSTMENT_LIST,
                    onClick: null
                },
                {
                    menuName: 'New Adjustment',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_ADD_MONEY_ADJUSTMENT,
                    onClick: null
                }
            ]
        },
        {
            main: MAIN_MENU_SHOP,
            children: [
                {
                    menuName: 'Shop List',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_SHOP_LIST,
                    onClick: null
                },
                {
                    menuName: 'New Shop',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_ADD_SHOP,
                    onClick: null
                }
            ]
        },
        {
            main: MAIN_MENU_CATEGORY,
            children: [
                {
                    menuName: 'All Categories',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_CATEGORY_LIST,
                    onClick: null
                },
                {
                    menuName: 'New Category',
                    checkRoles: RG_ADMIN,
                    gotoPage: ROUTE_CATEGORY_CREATE,
                    onClick: null
                },
            ]
        },
        {
            main: MAIN_MENU_SETTING,
            children: [
                {
                    menuName: 'Change Password',
                    checkRoles: RG_ALL_ROLES,
                    gotoPage: null,
                    onClick: () => handlePasswordChangeLinkClick()
                }
            ]
        }
    ];

    const isMenuGroupShow = (children) => {
        const toShowSubMenu = children?.filter(c => c.checkRoles?.includes(currentUser?.role));
        return toShowSubMenu && toShowSubMenu?.length > 0;
    }

    const initialValuesForUsernameChange = {
        username: currentUser?.username || "",
        password: "",
        confirmPassword: ""
    };

    const validationSchemaForUsernameChange = Yup.object({
        username: Yup.string()
            .min(3, 'Username must be at least 3 characters long.')
            .max(20, 'Username must not exceed 20 characters.')
            .required('Username is required.')
            .test(
                'is-different',
                'New username must be different from the current username.',
                (value) => value !== currentUser.username
            ),
        password: Yup.string()
            .max(50, 'Password must not exceed 50 characters.') // Max length validation
            .matches(/^[A-Za-z0-9!@#$%^&*()_+=-]+$/, 'Password can only contain alphabets, numbers, and special characters.')
            .required('Password is required.'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match.')  // Check if confirmPassword matches password
            .required('Confirm Password is required.')
    });

    const initialValuesForPasswordChange = {
        oldPassword: "",
        password: "",
        confirmPassword: ""
    };

    const validationSchemaForPasswordChange = Yup.object({
        oldPassword: Yup.string()
            .max(50, 'Password must not exceed 50 characters.') // Max length validation
            .matches(/^[A-Za-z0-9!@#$%^&*()_+=-]+$/, 'Password can only contain alphabets, numbers, and special characters.')
            .required('Old Password is required.'),
        password: Yup.string()
            .min(6, 'Password must have at least 6 characters.')
            .max(50, 'Password must not exceed 50 characters.') // Max length validation
            .matches(/^[A-Za-z0-9!@#$%^&*()_+=-]+$/, 'Password can only contain alphabets, numbers, and special characters.')
            .required('Password is required.'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match.')  // Check if confirmPassword matches password
            .required('Confirm Password is required.')
    });

    const onNameChangeSubmit = async (form) => {
        setLoading(true);
        try {
            const response = await changeUsername(currentUser.userId, form.username, form.password);
            if (response) {
                const { accessToken, refreshToken } = response;
                customStorage.setItem(TOKEN_SESSION_KEY, accessToken);
                customStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
                setToken(accessToken);
                setShowChangeUserNameDialog(false);
                setSuccessMessage("Username is successfully changed.");
            } else {
                setShowApiErrorMessage(SERVER_ERROR_MESSAGE)
            }
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const onPasswordChangeSubmit = async (form) => {
        setLoading(true);
        try {
            await changePassword(currentUser.userId, form.oldPassword, form.password);
            setShowSuccessPasswordChangedDialog(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const closeMenu = () => {
        if (offcanvasCloseBtnRef.current) {
            offcanvasCloseBtnRef.current.click();
            // document.body.removeAttribute("style");
        }
    };
    // const confirmLogout = () => {
    //     setShowLogoutConfirmDialog(true);
    // };
    const handleLogout = () => {
        closeMenu();
        logout();
        setShowLogoutConfirmDialog(false);
    };

    const renderNameChange = (
        <Container style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '30px' }}>
            {/* Header */}
            <h3 className="text-center">Hello! <span className='userNameField'>{currentUser?.username}</span></h3>

            {/* Login Form */}
            <Card style={{ width: '100%', maxWidth: '400px', padding: '20px', margin: '0 auto' }}>
                <Card.Body>
                    <h5 className="text-center mb-4">Change Username</h5>
                    <Formik
                        initialValues={initialValuesForUsernameChange}
                        validationSchema={validationSchemaForUsernameChange}
                        onSubmit={onNameChangeSubmit}
                        enableReinitialize={true}>
                        {({ errors, isValid, dirty }) => {
                            const firstError = !dirty ? "Fill the required fields." : Object.values(errors)[0];
                            return (
                                <Form>
                                    <div className="mb-3">
                                        <label className="form-label custom-label">Username*</label>
                                        <Field name="username" type="text" className="form-control customInputControl" autoComplete="off" />
                                        <ErrorMessage name="username" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label custom-label">Password*</label>
                                        <Field name="password" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                        <ErrorMessage name="password" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label custom-label">Confirm Password*</label>
                                        <Field name="confirmPassword" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                        <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
                                    </div>
                                    {/* Show Password Checkbox */}
                                    <div className="mb-3">
                                        <label className='custom-label'>
                                            <input
                                                type="checkbox"
                                                checked={showPassword}
                                                onChange={togglePasswordVisibility}
                                            />
                                            &nbsp;Show Password
                                        </label>
                                    </div>

                                    <Button
                                        className="w-100 mb-3"
                                        type="submit"
                                        variant="primary"
                                        disabled={!(isValid && dirty)}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        className="w-100 mb-3"
                                        type="button"
                                        variant="secondary"
                                        onClick={() => setShowChangeUserNameDialog(false)}
                                    >
                                        Cancel
                                    </Button>
                                </Form>
                            );
                        }}
                    </Formik>
                </Card.Body>
            </Card>
        </Container>
    );

    const renderPasswordChange = (
        <Container style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '30px' }}>
            {/* Header */}
            <h3 className="text-center">Hello! <span className='userNameField'>{currentUser?.username}</span></h3>

            {/* Login Form */}
            <Card style={{ width: '100%', maxWidth: '400px', padding: '20px', margin: '0 auto' }}>
                <Card.Body>
                    <h5 className="text-center mb-4">Change Password</h5>
                    <Formik
                        initialValues={initialValuesForPasswordChange}
                        validationSchema={validationSchemaForPasswordChange}
                        onSubmit={onPasswordChangeSubmit}
                        enableReinitialize={true}>
                        {({ errors, isValid, dirty }) => {
                            const firstError = !dirty ? "Fill the required fields." : Object.values(errors)[0];
                            return (
                                <Form>
                                    <div className="mb-3">
                                        <label className="form-label custom-label">Old Password*</label>
                                        <Field name="oldPassword" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                        <ErrorMessage name="oldPassword" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label custom-label">Password*</label>
                                        <Field name="password" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                        <ErrorMessage name="password" component="div" className="text-danger" />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label custom-label">Confirm Password*</label>
                                        <Field name="confirmPassword" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                        <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
                                    </div>
                                    {/* Show Password Checkbox */}
                                    <div className="mb-3">
                                        <label className='custom-label'>
                                            <input
                                                type="checkbox"
                                                checked={showPassword}
                                                onChange={togglePasswordVisibility}
                                            />
                                            &nbsp;Show Password
                                        </label>
                                    </div>

                                    <Button
                                        className="w-100 mb-3"
                                        type="submit"
                                        variant="primary"
                                        disabled={!(isValid && dirty)}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        className="w-100 mb-3"
                                        type="button"
                                        variant="secondary"
                                        onClick={() => setShowChangePasswordDialog(false)}
                                    >
                                        Cancel
                                    </Button>
                                </Form>
                            );
                        }}
                    </Formik>
                </Card.Body>
            </Card>
        </Container>
    );

    const handleSuccessDialogClose = () => {
        setSuccessMessage(null);
    }

    const handleEditUserNameClick = () => {
        closeMenu();
        setTimeout(() => {
            setShowChangeUserNameDialog(true);
        }, 400);
    }

    const handlePasswordChangeLinkClick = () => {
        closeMenu();
        setTimeout(() => {
            setShowChangePasswordDialog(true);
        }, 400);
    }

    return (
        currentUser && isInRole(RG_ALL_ROLES, currentUser.role) &&
        <div id='appNavbar'>
            <nav className="navbar bg-menu-top fixed-top">
                <div className="container-fluid">
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span className="offcanvas-title me-2" id="App_NavBarLabel"><strong>{APP_BRAND_NAME}</strong></span>
                        {routeNaviData && <span className='routeNaviText'>{routeNaviData}</span>}
                        <div className='routeNaviText'>
                            <i className="bi bi-person-fill icon-btn p-0 me-1"></i>
                            <span className='userNameNavTop'>{currentUser?.username || "Unknown User"}</span>
                        </div>
                    </div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#App_NavBar" aria-controls="App_NavBar" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="offcanvas offcanvas-end" tabIndex="-1" id="App_NavBar" aria-labelledby="App_NavBarLabel">
                        <div className="offcanvas-header">
                            <div>
                                <i className="bi bi-person-fill userIconNavTop"></i>
                                <span className='userNameNavTop'>{currentUser?.username || "Unknown User"}</span>
                                <button className='icon-btn' onClick={handleEditUserNameClick}>
                                    <i className="bi bi-pencil-square"></i>
                                </button>
                            </div>
                            <button type="button" className="btn-close" ref={offcanvasCloseBtnRef} data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body menuSection">
                            {menuList.map((menu, index) => {
                                return (
                                    isMenuGroupShow(menu.children) && <div className='menuGroup' key={index}>
                                        <div className={`menuGroupName ${mainMenu === menu.main ? 'active' : ''}`}>{menu.main}</div>
                                        <ul className="navbar-nav justify-content-end flex-grow-1">
                                            {menu.children.map((child, index) => {
                                                return (
                                                    !!child.gotoPage ?
                                                        ((!child.checkRoles || (isInRole(child.checkRoles, currentUser?.role))) &&
                                                            <li className="nav-item" key={index}>
                                                                <NavLink
                                                                    draggable={false}
                                                                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''} menuGroupItem`}
                                                                    to={child.gotoPage}
                                                                    onClick={closeMenu}>
                                                                    {child.menuName}
                                                                </NavLink>
                                                            </li>) :
                                                        <li className="nav-item" key={index}>
                                                            <button className="nav-link btn menuGroupItem" onClick={() => child.onClick()}>
                                                                {child.menuName}
                                                            </button>
                                                        </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                )
                            })}

                            {/* Logout Button */}
                            <div className="logout-btn-container">
                                <button className="btn btn-danger w-100" onClick={() => setShowLogoutConfirmDialog(true)}>
                                    Logout <i className="bi bi-power"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <ConfirmDialog
                dialogId='logoutConfirmDialog'
                showDialog={showLogoutConfirmDialog}
                // title='Logout Dialog'
                body='Are you sure to logout?'
                onConfirm={handleLogout}
                onCancel={() => setShowLogoutConfirmDialog(false)}
            />
            <CommonDialog
                dialogId='changeUsernameDialog'
                show={showChangeUserNameDialog}
                // noCloseBtn={false}
                // onHide={() => setShowChangeUserNameDialog(false)}
                onHide={() => setShowPassword(false)}
                size={'fullscreen'}
                body={renderNameChange}
            />
            <CommonDialog
                dialogId='changePasswordDialog'
                show={showChangePasswordDialog}
                // noCloseBtn={false}
                // onHide={() => setShowChangeUserNameDialog(false)}
                onHide={() => { setShowPassword(false); setShowChangePasswordDialog(false); closeMenu(); }}
                size={'fullscreen'}
                body={renderPasswordChange}
            />
            <AlertDialog
                dialogId={'successUsernameChangeDialog'}
                showDialog={!isNullOrEmptyString(successMessage)}
                body={successMessage}
                onConfirm={handleSuccessDialogClose}
            />

            <AlertDialog
                dialogId={'successPasswordChangeDialog'}
                showDialog={showSuccessPasswordChangedDialog}
                body={<>
                    <div>Password has been successfully changed. <br />You will be logged out automatically.</div>
                </>}
                onConfirm={() => handleLogout()}
            />
        </div>
    );
};

export default Navbar;